import { render, staticRenderFns } from "./CustomPagination.vue?vue&type=template&id=956101d6&"
import script from "./CustomPagination.vue?vue&type=script&lang=js&"
export * from "./CustomPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('956101d6')) {
      api.createRecord('956101d6', component.options)
    } else {
      api.reload('956101d6', component.options)
    }
    module.hot.accept("./CustomPagination.vue?vue&type=template&id=956101d6&", function () {
      api.rerender('956101d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Budget/CustomPagination.vue"
export default component.exports